import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class EcoFeeStyle {
	public static getStyle(options: { theme: ITheme }): string {
		return css`
			:host {
				display: flex;
				flex-direction: column;
			}

			.link {
				cursor: pointer;
				outline: none;
				text-decoration: underline;
				color: ${options.theme.color.text.default};
			}
		`;
	}
}
